// extracted by mini-css-extract-plugin
export default {"wrapper":"GoalCard_wrapper__FONsO","title":"GoalCard_title__8u2Lf","removeButton":"GoalCard_removeButton__Edybp"};